import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { connect } from 'react-redux'
import ArrowDown from '../../assets/ArrowDown'
import ChevronUp from '../../assets/ChevronUp'
import { redirect } from '../../common/utils/redirectionUtils'
import Header from '../Common/Header/Header'
import SideMenu from '../Common/SideMenu/SideMenu'
import './Home.scss'
import {
  GET_PERMISSION_INITIAL_DATA,
  HOME_NAVIGATION_ITEMS,
  PAGE_CONST,
  PERMISSION_FEATURE,
  PERMISSION_SCREEN,
  PERMISSION_TYPE,
  REACT_NATIVE_WEBVIEW_CONST,
} from '../../common/constant/page-constant'
import {
  activeHomeDetailNavigation,
  loginDataAction,
  updateBranchDataAction,
} from '../../modules/actions/action'
// import Stocks from '../Stocks/Stocks'
import useCheckMobileScreen from '../../common/hooks/use-check-mobile-screen-hook'
import MobileHeader from '../Common/Header/MobileHeader'
import {
  HEADER_CONFIG,
  HEADER_CONST,
  SIDEBAR_CONST,
} from '../../common/constant/common-constant'
import ChevronDown from '../../assets/ChevronDown'
import Stocks from '../Stocks/Stocks'
import { getHomeDataHelper } from '../../helper/settings-helper'

const Home = (props) => {
  const navigate = useNavigate()
  const isMobile = useCheckMobileScreen()
  const [loginData, setLoginData] = useState({})
  const [permissions, setPermissions] = useState({})
  const [homeData, setHomeData] = useState({})
  const [statsData, setStatsData] = useState({})
  const [startDate, setStartDate] = useState(undefined)
  const [endDate, setEndDate] = useState(undefined)

  const selectRef = useRef(null)

  useEffect(() => {
    getHomeData()
  }, [])

  useEffect(() => {
    setLoginData(props.loginData)

    if (props.loginData.permissions) {
      console.log('props.loginData.permissions: ', props.loginData.permissions)

      let permission = props.loginData.permissions.reduce((acc, permission) => {
        acc.features = {
          ...acc.features,
          ...permission.features,
        }

        return acc
      }, {})

      console.log('home screen permission: ', permission)
      if (permission) setPermissions(permission)
    }
  }, [props.loginData])

  const getHomeData = async () => {
    try {
      let data = await getHomeDataHelper(startDate, endDate)
      setHomeData(data)
    } catch (err) {
      console.log('err: ', err)
    }
  }

  const [headerOptions] = useState({
    [HEADER_CONFIG.IS_BACK_VISIBLE]: false,
    [HEADER_CONFIG.TITLE]: HEADER_CONST.HOME,
  })

  const handleSubmitClick = () => {
    console.log('startDate, endDate: ', startDate, endDate)
    if (!startDate || !endDate) {
      return
    }

    getHomeData()
  }

  return (
    <div className="containerHome">
      {!isMobile && <Header />}
      {isMobile && <MobileHeader headerOptions={headerOptions} />}
      <SideMenu activeItem={SIDEBAR_CONST.HOME} component={PAGE_CONST.HOME} />
      <div className="pageBody dFlex">
        <div className="homeLeftWrapper">
          {/* Sales Orders*/}
          {(permissions?.features?.[PERMISSION_FEATURE.SALES_ORDER] !==
            PERMISSION_TYPE.RESTRICTED ||
            permissions?.features?.[PERMISSION_FEATURE.SALES_AMOUNT] !==
              PERMISSION_TYPE.RESTRICTED ||
            permissions?.features?.[PERMISSION_FEATURE.REVENUE] !==
              PERMISSION_TYPE.RESTRICTED ||
            permissions?.features?.[PERMISSION_FEATURE.USERS_ONBOARDED] !==
              PERMISSION_TYPE.RESTRICTED) && (
            <div className="chooseTimeline dFlex aiCenter">
              <div className="formInline dFlex">
                {
                  <>
                    <div className="formGroup formFloating mb-0 flex1">
                      <input
                        type="date"
                        className="formControl"
                        id="email"
                        placeholder="From"
                        value={startDate}
                        onChange={(event) => {
                          console.log(event.target.value)

                          // emptyData()
                          setStartDate(event.target.value)
                        }}
                        required
                      />
                      <label for="address">From</label>
                    </div>
                    <div className="formGroup formFloating ml-4 mb-0 flex1">
                      <input
                        type="date"
                        className="formControl"
                        id="email"
                        placeholder="To"
                        value={endDate}
                        onChange={(event) => {
                          console.log(event.target.value)
                          // emptyData()
                          setEndDate(event.target.value)
                        }}
                        required
                      />
                      <label for="address">To</label>
                    </div>
                    {
                      <div
                        className={`dFlex ${
                          !isMobile ? 'ml-4' : 'mt-5 flexBreak50'
                        }`}
                      >
                        <button
                          className="btn btnPrimary flexBreak"
                          onClick={() => handleSubmitClick()}
                        >
                          GO
                        </button>
                      </div>
                    }
                  </>
                }
              </div>
              {/* {!isMobile && (
                                <div className="pointer ml-4">
                                    <CloseIcon />
                                </div>
                            )} */}
            </div>
          )}
          {permissions?.features?.[PERMISSION_FEATURE.SALES_ORDER] !==
            PERMISSION_TYPE.RESTRICTED && (
            <div className="homeBar pt-0">
              <div className="centerDetailsWrap">
                <div className="centerOwner strong">Sales Orders</div>
              </div>
              {
                <>
                  <div className="moneyBar dFlex jcSpaceBetween">
                    <div className="moneyBarItem">DG ePharma</div>
                    <div className="moneyBarItem">
                      <div className="moneyBarItemHeading">Online</div>
                      <div className="moneyBarValue dFlex aiCenter">
                        <div className="headingValue">
                          {
                            homeData?.sales_orders?.dg_e_pharma
                              ?.online_orders_count
                          }
                        </div>
                      </div>
                    </div>
                    <div className="moneyBarItem">
                      <div className="moneyBarItemHeading">Offline</div>
                      <div className="moneyBarValue dFlex aiCenter">
                        <div className="headingValue">
                          {
                            homeData?.sales_orders?.dg_e_pharma
                              ?.offline_orders_count
                          }
                        </div>
                      </div>
                    </div>
                    <div className="moneyBarItem">
                      <div className="moneyBarItemHeading">Cancelled</div>
                      <div className="moneyBarValue dFlex aiCenter">
                        <div className="headingValue">
                          {
                            homeData?.sales_orders?.dg_e_pharma
                              ?.cancelled_orders_count
                          }
                        </div>
                      </div>
                    </div>
                    <div className="moneyBarItem">
                      <div className="moneyBarItemHeading">Total</div>
                      <div className="moneyBarValue dFlex aiCenter">
                        <div className="headingValue">
                          {homeData?.sales_orders?.dg_e_pharma?.total}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="moneyBar dFlex jcSpaceBetween">
                    <div className="moneyBarItem">DG Med B2B</div>
                    <div className="moneyBarItem">
                      <div className="moneyBarItemHeading">Online</div>
                      <div className="moneyBarValue dFlex aiCenter">
                        <div className="headingValue">
                          {
                            homeData?.sales_orders?.dg_med_b2b
                              ?.online_orders_count
                          }
                        </div>
                      </div>
                    </div>
                    <div className="moneyBarItem">
                      <div className="moneyBarItemHeading">Offline</div>
                      <div className="moneyBarValue dFlex aiCenter">
                        <div className="headingValue">
                          {
                            homeData?.sales_orders?.dg_med_b2b
                              ?.offline_orders_count
                          }
                        </div>
                      </div>
                    </div>
                    <div className="moneyBarItem">
                      <div className="moneyBarItemHeading">Cancelled</div>
                      <div className="moneyBarValue dFlex aiCenter">
                        <div className="headingValue">
                          {
                            homeData?.sales_orders?.dg_med_b2b
                              ?.cancelled_orders_count
                          }
                        </div>
                      </div>
                    </div>
                    <div className="moneyBarItem">
                      <div className="moneyBarItemHeading">Total</div>
                      <div className="moneyBarValue dFlex aiCenter">
                        <div className="headingValue">
                          {homeData?.sales_orders?.dg_med_b2b?.total}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              }
            </div>
          )}
          {/* Sales Orders (BDT)*/}
          {permissions?.features?.[PERMISSION_FEATURE.SALES_AMOUNT] !==
            PERMISSION_TYPE.RESTRICTED && (
            <div className="homeBar">
              <div className="centerDetailsWrap dFlex">
                <div className="centerOwner strong">Sales (BDT)</div>
                <div className="centerName">
                  {' '}
                  {parseFloat(
                    homeData?.sales?.dg_e_pharma?.total +
                      homeData?.sales?.dg_med_b2b?.total
                  ).toFixed(2)}
                </div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              {
                <>
                  <div className="moneyBar dFlex jcSpaceBetween">
                    <div className="moneyBarItem">DG ePharma</div>
                    <div className="moneyBarItem">
                      <div className="moneyBarItemHeading">Online Amount</div>
                      <div className="moneyBarValue dFlex aiCenter">
                        <div className="headingValue">
                          {homeData?.sales?.dg_e_pharma?.online_orders_sales}
                        </div>
                      </div>
                    </div>
                    <div className="moneyBarItem">
                      <div className="moneyBarItemHeading">Offline Amount</div>
                      <div className="moneyBarValue dFlex aiCenter">
                        <div className="headingValue">
                          {homeData?.sales?.dg_e_pharma?.offline_orders_sales}
                        </div>
                      </div>
                    </div>
                    <div className="moneyBarItem">
                      <div className="moneyBarItemHeading">Total Amount</div>
                      <div className="moneyBarValue dFlex aiCenter">
                        <div className="headingValue">
                          {homeData?.sales?.dg_e_pharma?.total}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="moneyBar dFlex jcSpaceBetween">
                    <div className="moneyBarItem">DG Med B2B</div>
                    <div className="moneyBarItem">
                      <div className="moneyBarItemHeading">Online Amount</div>
                      <div className="moneyBarValue dFlex aiCenter">
                        <div className="headingValue">
                          {homeData?.sales?.dg_med_b2b?.online_orders_sales}
                        </div>
                      </div>
                    </div>
                    <div className="moneyBarItem">
                      <div className="moneyBarItemHeading">Offline Amount</div>
                      <div className="moneyBarValue dFlex aiCenter">
                        <div className="headingValue">
                          {homeData?.sales?.dg_med_b2b?.offline_orders_sales}
                        </div>
                      </div>
                    </div>
                    <div className="moneyBarItem">
                      <div className="moneyBarItemHeading">Total Amount</div>
                      <div className="moneyBarValue dFlex aiCenter">
                        <div className="headingValue">
                          {homeData?.sales?.dg_med_b2b?.total}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              }
            </div>
          )}
          {/* Revenue (BDT)*/}
          {permissions?.features?.[PERMISSION_FEATURE.REVENUE] !==
            PERMISSION_TYPE.RESTRICTED && (
            <div className="homeBar">
              <div className="centerDetailsWrap dFlex ">
                <div className="centerOwner strong">Revenue (BDT)</div>
                <div className="centerName">
                  {parseFloat(
                    homeData?.revenue?.dg_e_medical?.total +
                      homeData?.revenue?.dg_e_pharma?.total +
                      homeData?.revenue?.dg_med_b2b?.total
                  ).toFixed(2)}
                </div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              {
                <>
                  <div className="moneyBar dFlex jcSpaceBetween">
                    <div className="moneyBarItem">DG eMedical</div>
                    <div className="moneyBarItem">
                      <div className="moneyBarItemHeading">
                        Commission Earning
                      </div>
                      <div className="moneyBarValue dFlex aiCenter">
                        <div className="headingValue">
                          {homeData?.revenue?.dg_e_medical?.commission_earning}
                        </div>
                      </div>
                    </div>
                    <div className="moneyBarItem">
                      <div className="moneyBarItemHeading">Platform Charge</div>
                      <div className="moneyBarValue dFlex aiCenter">
                        <div className="headingValue">
                          {homeData?.revenue?.dg_e_medical?.platform_charges}
                        </div>
                      </div>
                    </div>
                    <div className="moneyBarItem">
                      <div className="moneyBarItemHeading">Total Earnings</div>
                      <div className="moneyBarValue dFlex aiCenter">
                        <div className="headingValue">
                          {homeData?.revenue?.dg_e_medical?.total}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="moneyBar dFlex jcSpaceBetween">
                    <div className="moneyBarItem">DG ePharma</div>
                    <div className="moneyBarItem">
                      <div className="moneyBarItemHeading">
                        Commission Earning
                      </div>
                      <div className="moneyBarValue dFlex aiCenter">
                        <div className="headingValue">
                          {homeData?.revenue?.dg_e_pharma?.commission_earning}
                        </div>
                      </div>
                    </div>
                    <div className="moneyBarItem">
                      <div className="moneyBarItemHeading">Platform Charge</div>
                      <div className="moneyBarValue dFlex aiCenter">
                        <div className="headingValue">
                          {homeData?.revenue?.dg_e_pharma?.platform_charges}
                        </div>
                      </div>
                    </div>
                    <div className="moneyBarItem">
                      <div className="moneyBarItemHeading">Total Earnings</div>
                      <div className="moneyBarValue dFlex aiCenter">
                        <div className="headingValue">
                          {homeData?.revenue?.dg_e_pharma?.total}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="moneyBar dFlex jcSpaceBetween">
                    <div className="moneyBarItem">DG Med B2B</div>
                    <div className="moneyBarItem">
                      <div className="moneyBarItemHeading">
                        Commission Earning
                      </div>
                      <div className="moneyBarValue dFlex aiCenter">
                        <div className="headingValue">
                          {homeData?.revenue?.dg_med_b2b?.commission_earning}
                        </div>
                      </div>
                    </div>
                    <div className="moneyBarItem">
                      <div className="moneyBarItemHeading">Platform Charge</div>
                      <div className="moneyBarValue dFlex aiCenter">
                        <div className="headingValue">
                          {homeData?.revenue?.dg_med_b2b?.platform_charges}
                        </div>
                      </div>
                    </div>
                    <div className="moneyBarItem">
                      <div className="moneyBarItemHeading">Total Earnings</div>
                      <div className="moneyBarValue dFlex aiCenter">
                        <div className="headingValue">
                          {homeData?.revenue?.dg_med_b2b?.total}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              }
            </div>
          )}
          {/* Users Onboarded*/}
          {permissions?.features?.[PERMISSION_FEATURE.USERS_ONBOARDED] !==
            PERMISSION_TYPE.RESTRICTED && (
            <div className="homeBar">
              <div className="centerDetailsWrap dFlex ">
                <div className="centerOwner strong">Users Onboarded</div>
                <div className="centerName">
                  {homeData?.users_onboarded?.dg_e_medical +
                    homeData?.users_onboarded?.dg_e_pharma +
                    homeData?.users_onboarded?.dg_med_b2b}
                </div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              {
                <>
                  <div className="moneyBar dFlex jcSpaceBetween">
                    <div className="moneyBarItem">{`Platforms`}</div>
                    <div className="moneyBarItem">
                      <div className="moneyBarItemHeading">DG eMedical</div>
                      <div className="moneyBarValue dFlex aiCenter">
                        <div className="headingValue">
                          {homeData?.users_onboarded?.dg_e_medical}
                        </div>
                      </div>
                    </div>
                    <div className="moneyBarItem">
                      <div className="moneyBarItemHeading">DG ePharma</div>
                      <div className="moneyBarValue dFlex aiCenter">
                        <div className="headingValue">
                          {homeData?.users_onboarded?.dg_e_pharma}
                        </div>
                      </div>
                    </div>
                    <div className="moneyBarItem">
                      <div className="moneyBarItemHeading">DG Med B2B</div>
                      <div className="moneyBarValue dFlex aiCenter">
                        <div className="headingValue">
                          {homeData?.users_onboarded?.dg_med_b2b}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              }
            </div>
          )}
        </div>
        {!isMobile &&
          permissions?.features?.[PERMISSION_FEATURE.BAR_CHART] !==
            PERMISSION_TYPE.RESTRICTED && (
            <div className="homeRightWrapper">
              <ul className="tabs dFlex">
                <li className="tabItem active total-earning">Total Earnings</li>
                {/* <li className="tabItem">Reminders</li> */}
              </ul>
              <div className="tabContent">
                <div className="tabPane">
                  <Stocks data={homeData?.bar_chart_data} />
                </div>
              </div>
            </div>
          )}
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    loginData: state.loginDataReducer?.loginData,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    // activeHomeDetailNavigation: payload =>
    //     dispatch(activeHomeDetailNavigation(payload)),
    // loginDataAction: payload => dispatch(loginDataAction(payload)),
    // updateBranchDataAction: payload =>
    //     dispatch(updateBranchDataAction(payload))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home)
